import { Flame, Clock, Star } from "lucide-react";
import { IMG } from "./data";
import { Reveal, Eyebrow } from "./Reveal";

const FACTS = [
  { icon: Flame, label: "Charcoal grilled" },
  { icon: Clock, label: "4 PM — 11:30 PM daily" },
  { icon: Star, label: "5.0 on Google" },
];

export default function Story() {
  return (
    <section id="story" className="py-28 md:py-40 overflow-hidden" data-testid="story-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -inset-3 rounded-2xl border border-gold/30 translate-x-4 translate-y-4 pointer-events-none" />
            <img
              src={IMG.platter}
              alt="Arab mixed grill platter with flatbread"
              loading="lazy"
              className="relative rounded-2xl w-full aspect-[4/3] object-cover brightness-90 saturate-[0.9]"
            />
            <div className="absolute -bottom-6 -right-2 md:right-6 rounded-xl bg-cardc/95 backdrop-blur border border-white/10 px-5 py-4 flex items-center gap-3">
              <span className="font-arabic text-4xl text-ember leading-none">ن</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim leading-relaxed">
                Nun — the Arabic
                <br />
                letter N
              </span>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow className="mb-4">Our story</Eyebrow>
            <h2 className="font-display font-semibold text-4xl md:text-6xl leading-tight">
              The Arab art of the ember, in the heart of Kadri.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-dim text-base md:text-lg leading-relaxed">
              Nuun Kebabs brings the charcoal grills of the Arab world to
              Mallikatte. Every evening the coals are lit, the skewers are
              hand-pressed, and Mangaluru gets a taste of Adana, Sultana and
              Shish Tawook — done the slow, smoky, honest way.
            </p>
            <p className="mt-5 text-dim text-base md:text-lg leading-relaxed">
              Come hungry. Leave smelling faintly of smoke, and planning your
              next visit before you reach the door.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-3">
              {FACTS.map(({ icon: Icon, label }) => (
                <span
                  key={label}
                  className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-bone/85"
                >
                  <Icon className="w-4 h-4 text-ember" />
                  {label}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
